import React from 'react'
import styled from '@emotion/styled'
import PermissionsItem from 'views/UserManagement/Permissions/PermissionsItem'

const StyledProjects = styled.div({})

const ProjectsPermissions = ({ projects, ...rest }) => {
  return (
    <StyledProjects>
      {projects.map(project => (
        <PermissionsItem key={project.id} project={project} {...rest} />
      ))}
    </StyledProjects>
  )
}

export default ProjectsPermissions
